import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.Availability.title',
    defaultMessage: 'My availability',
  },
  absences: {
    id: 'app.components.Availability.absences',
    defaultMessage: 'Absences',
  },
  timesForAutomaticApplications: {
    id: 'app.components.Availability.timesForAutomaticApplications',
    defaultMessage: 'Times for automatic applications',
  },
  back: {
    id: 'app.components.Availability.back',
    defaultMessage: 'Back',
  },
});
